
import {RemoteHttpService} from '../../remote-http';
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {Advertisement} from '../../data/advertisement';
import * as global from '../../globals';
import {RemoteRequest, ContentType} from '../../remote-request';
import {JsonService} from '../../json-util';
import { map } from "rxjs/operators";
import { Custom_RequestMethod } from '../common-service';

@Injectable()
export class AdService {
    constructor(private http: RemoteHttpService,
        private requestMethod:Custom_RequestMethod
        ){
    }

    /**
     * Get Ads to display in general area.
     * @returns {Observable<Advertisement[]>}
     */
    public getAdToDisplay(): Observable<Advertisement[]> {
        let url = global.ServerUrls.getAdsForDisplay;
        let request = new RemoteRequest(url, this.requestMethod.get,
            ContentType.URL_ENCODED_FORM_DATA, {
                portalOrApp     : 'app'
            });
        return this._getAds(request);
    }

    /**
     * Get the list of ads to display for a given specific competition
     * @param {number} competitionId The ID of the competition
     * @returns {Observable<Advertisement[]>}
     */
    public getCompetitionAds(competitionId: number): Observable<Advertisement[]> {
        let url = global.ServerUrls.getAdsForDisplay;
        let request = new RemoteRequest(url, this.requestMethod.get,
            ContentType.URL_ENCODED_FORM_DATA, {
                portalOrApp     : 'app',
                competitionId: competitionId
            });
        return this._getAds(request);
    }

    private _getAds(request: RemoteRequest): Observable<Advertisement[]>  {
        return   this.http.execute(request).pipe(map((result:any) => {
            let ads : Advertisement[] = result.json();
                       if(ads && ads.length)
                           ads.forEach(ad=>{
                               JsonService.deriveFullUrl(ad,'imageUrl');
                           });
                       return ads;
        }))  
    }
}